import styled from "styled-components"
import { validColor, darkBorder, darkFontColor, darkBackground } from "./helpers"

export const StyledLookupOptions = styled.div`
    background: ${({ isDark }) => darkBackground(isDark)};
    border: 1px solid ${({ isDark }) => darkBorder(isDark)};
    padding: 8px;
    position: absolute;
    top: calc(100% - 3px);
    width: 100%;
    max-height: 175px;
    overflow-y:scroll;
    left: 0;
    z-index: 1;
    border-radius: 0 0 4px 4px;

    & > div{
        padding: 8px;
        border-radius: 4px;
        cursor: pointer;
        transition: .2s;
        font-size: 14px;
        font-family: ${props => props.theme.fonts.circularBook};
        line-height: 1;
        color: ${props => props.theme.colors.darkGrey};
        display: flex;
        flex-direction: column;
        @media (max-width: 1024px){
            font-size: 12px;
        }

        & > span{
            font-size: 12px;
            margin-top: 4px;
            color: ${props => props.theme.colors.darkGrey80};
            @media (max-width: 1024px){
                font-size: 10px;
            }
        }

        &:hover{
            background: ${props => props.theme.colors.darkGrey05};
        }
    }
`
export const StyledSelectedOption = styled.div`
    padding: 8px;
    margin-top: 4px;
    display: flex;
    min-height: 54px;
    align-items: center;
    justify-content: space-between;
    border-radius: 4px;
    cursor: pointer;
    ${props => props.isDark ? `
        background: ${props.theme.colors.white20};
    ` : `
        background: ${props.theme.colors.darkGrey05};
    `}
    @media (max-width: ${props => props.theme.breakPoints.desktop}) {
        min-height: 46px;
    }
    
    & > p{
        font-family: ${props => props.theme.fonts.circularBook};
        line-height: 1;
        font-size: 14px;
        ${props => props.isDark ? `
            color: ${props.theme.colors.white};
        ` : `
            color: ${props.theme.colors.darkGrey};
        `}
        @media (max-width: 1024px){
            font-size: 12px;
        }
    }

    & > i{
        line-height: 1;
        height: 16px;
        width: 16px;
        display: flex;
        align-items: center;

        & svg{
            ${props => props.isDark ? `
            color: ${props.theme.colors.white};
        ` : `
            color: ${props.theme.colors.darkGrey};
        `}
        }
    }
`